document.addEventListener('DOMContentLoaded', function () {
  const phoneInput = document.getElementById('RegisterForm-phone');
  const phoneError = document.getElementById('RegisterForm-phone-error');

  if (!phoneInput) return;

  const form = phoneInput.closest('form');
  const submitButton = form.querySelector(
    'button[type="submit"], input[type="submit"]'
  );

  function validatePhone() {
    const phoneValue = phoneInput.value.trim();
    const phoneRegex = /^\d{10,15}$/;

    if (phoneValue === '') {
      phoneError.textContent = 'Telepon tidak boleh kosong';
      phoneError.style.display = 'block';
      phoneInput.setAttribute('aria-invalid', 'true');
      return false;
    }

    if (!phoneRegex.test(phoneValue)) {
      phoneError.textContent =
        'Format telepon salah. Gunakan 10-15 digit angka.';
      phoneError.style.display = 'block';
      phoneInput.setAttribute('aria-invalid', 'true');
      return false;
    }

    phoneError.style.display = 'none';
    phoneInput.removeAttribute('aria-invalid');

    return true;
  }

  phoneInput.addEventListener('input', validatePhone);

  if (submitButton) {
    submitButton.addEventListener('click', function (e) {
      const isValid = validatePhone();

      if (!isValid) {
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();

        phoneInput.focus();

        return false;
      }
    });
  }

  if (form) {
    form.addEventListener('submit', function (e) {
      const isValid = validatePhone();

      if (!isValid) {
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();

        phoneInput.focus();

        return false;
      }
    });
  }
});